 @if(!templateForPermitForm){

<button
  class="btn btn-raised btn-primary"
  type="button"
  (click)="launchChild()"
>
  <span *ngIf="callActivity.status !== ActivityStatus.Completed">Open</span>
  <span *ngIf="callActivity.status === ActivityStatus.Completed">
    Open Summary
  </span>
</button>
}
 @else{
  <div style="margin-top: 10px;margin-bottom: 10px;">
  @if(callActivity.childApplicationStatus === 1 && callActivity.status === ActivityStatus.InProgress){
   <wm-common-button
    [data]="{
      text: 'Open' ,
      variant: 'flat',
      className: 'button-radius-4 w-80',
      onClick:launchChild.bind(this)
    }"
  ></wm-common-button>

  }@else{
    <wm-common-button
    [data]="{
      text: 'View Summary' ,
      variant: 'flat',
      className: 'button-radius-4 w-80',
      onClick:launchChildSummary.bind(this)
    }"
  ></wm-common-button>
  }
  @if(showSummary === true){
        <!-- show view summary here -->
     <wm-application-summary [appId]="callActivity.model.callingWorkflowApplicationId" [renderPrintMode]="true" [bgWhite]="summaryViewBGJanus" [showPrint]="false" [allowReopenChildInspectionApplicationsParentActivityId]="allowReopenChildInspectionApplicationsParentActivityId" ></wm-application-summary>
  }
  </div>
 }
<wm-common-confirmation-modal [data]="launchWorkflowApplicationModalData" (onYesClick)="handlelaunchWorkflowApplicationModalAccepted()"
    (onNoClick)="handlelaunchWorkflowApplicationModalRejected()" [isApplicantMobileview]="true">
</wm-common-confirmation-modal>
